import React from 'react';
import { Checkbox as MuiCheckbox, FormControlLabel } from '@mui/material';
import { colorPrimary } from '../../Styles/Colors';

const Checkbox = ({ checked, onChange, label, sx = {}, style = {}, ...props }) => {
  return (
    <FormControlLabel
      control={
        <MuiCheckbox 
          checked={checked} 
          onChange={onChange}
          sx={{
            color: colorPrimary,
            '&.Mui-checked': {
              color: colorPrimary,
            },
            ...style,
            ...sx,
            border: 'none',
          }}
          {...props}
        />
      }
      label={label}
      sx={{
        padding: 0,
        margin: 0,
        ...style,
        ...sx,
        border: 'none',
      }}
    />
  );
};

export default Checkbox;
